import { createSlice } from "redux-starter-kit";
import menuTree from "./analystDirectoryFilterItems.json";

const initialSelected = { regions: ["All"], assets: ["All"], subAssets: ["All"] };
const findItems = (selected) => {
  return {
    regions: Object.keys(menuTree).map((label) => ({ label: label, isSelected: selected.regions.includes(label) })),
    assets: Object.keys(menuTree["Japan"]).map((label) => ({
      label: label,
      isSelected: selected.assets.includes(label),
    })),
    subAssets: findSubAssets(selected).map((label) => ({
      label: label,
      isSelected: selected.subAssets.includes(label),
    })),
  };
};

export const analystDirectoryFilterSlice = createSlice({
  slice: "analystDirectoryFilter",
  initialState: { items: findItems(initialSelected), selected: initialSelected },
  reducers: {
    toggle: (state, action) => {
      const { key, value } = action.payload;
      state.selected[key] = !state.selected[key].includes(value)
        ? state.selected[key].concat(value)
        : state.selected[key].filter((i) => i !== value);
      value === "All" || state.selected[key].length === 0
        ? (state.selected[key] = ["All"])
        : (state.selected[key] = state.selected[key].filter((i) => i !== "All"));
      state.items = findItems(state.selected);
    },
  },
});

function findSubAssets(selected) {
  let subAssets = [];
  selected.regions.map((region) =>
    selected.assets.map((asset) => Object.keys(menuTree[region][asset]).map((subAsset) => subAssets.push(subAsset)))
  );
  subAssets = subAssets.filter(onlyUnique);
  subAssets.unshift("All");
  return subAssets;
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}
